import { useAdminPortalConfig } from 'api/adminPortalConfig';
import { useProjectCtx } from './project/ProjectCtx';
import { useThemeCtx } from './theme/ThemeCtx';

export const useAppInitialized = () => {
	const { projectId, initialized } = useProjectCtx();
	const { themeLoaded } = useThemeCtx();

	return initialized && (themeLoaded || !projectId);
};

export const useAppInitError = () => {
	const { themeLoadError } = useThemeCtx();
	const { isError: adminPortalConfigError } = useAdminPortalConfig();

	return themeLoadError || adminPortalConfigError;
};
